import { Plus, X } from "lucide-react";

const MATCH = ["EXACT", "PHRASE", "BROAD"];

export default function NegativesEditor({ items = [], onChange, testid, showReason = false }) {
  const set = (i, k, v) => onChange(items.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  return (
    <div data-testid={testid} className="space-y-2">
      {items.map((n, i) => (
        <div key={i} className="flex flex-wrap items-center gap-2">
          <span className="font-mono text-xs text-red-300">−</span>
          <input data-testid={`${testid}-text-${i}`} className="cc-input min-w-[160px] flex-1 font-mono text-xs" value={n.text || ""} onChange={(e) => set(i, "text", e.target.value)} />
          <select data-testid={`${testid}-match-${i}`} className="cc-input w-28 font-mono text-xs" value={n.match_type || "PHRASE"} onChange={(e) => set(i, "match_type", e.target.value)}>
            {MATCH.map((m) => <option key={m}>{m}</option>)}
          </select>
          <button type="button" data-testid={`${testid}-remove-${i}`} onClick={() => onChange(items.filter((_, j) => j !== i))} className="cc-btn cc-btn-ghost px-2"><X className="h-3.5 w-3.5" /></button>
          {showReason && n.reason && <div className="w-full pl-4 text-xs text-slate-500">{n.reason}</div>}
        </div>
      ))}
      <button type="button" data-testid={`${testid}-add`} onClick={() => onChange([...items, { text: "", match_type: "PHRASE" }])} className="flex items-center gap-1.5 text-xs text-emerald-400 hover:text-emerald-300"><Plus className="h-3.5 w-3.5" /> Add negative keyword</button>
    </div>
  );
}

export const LiveNegatives = ({ items = [], testid }) => (
  <div data-testid={testid}>
    {items.length === 0 ? <p className="text-sm text-slate-500">No negative keywords found in the account (or not synced yet).</p> : (
      <div className="max-h-80 space-y-1 overflow-y-auto">
        {items.map((n, i) => (
          <div key={i} className="flex items-center justify-between gap-3 border-b border-[#1e293b] py-1.5 text-xs last:border-0">
            <span className="font-mono text-slate-200">−{n.match_type === "EXACT" ? `[${n.text}]` : n.match_type === "PHRASE" ? `"${n.text}"` : n.text}</span>
            <span className="truncate text-slate-500">{n.level} · {n.scope}</span>
          </div>
        ))}
      </div>
    )}
  </div>
);
